import type { ButtonHTMLAttributes, PropsWithChildren } from "react";

import { cn } from "../../lib/cn";

type ButtonVariant = "primary" | "secondary" | "ghost" | "danger";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  fullWidth?: boolean;
}

const variantClasses: Record<ButtonVariant, string> = {
  primary:
    "bg-accent text-white shadow-glow hover:bg-accent-strong focus-visible:outline-accent disabled:bg-accent-muted/50",
  secondary:
    "border border-white/10 bg-surface-soft text-ink hover:border-accent/40 hover:text-white focus-visible:outline-accent disabled:text-ink-muted disabled:border-white/5",
  ghost:
    "bg-transparent text-ink-soft hover:bg-white/5 hover:text-white focus-visible:outline-accent disabled:text-ink-muted",
  danger:
    "bg-[#381018] text-[#ffdce2] hover:bg-[#4f1623] focus-visible:outline-[#ff6a84] disabled:bg-[#2b1218]"
};

export function Button({
  children,
  className,
  disabled,
  fullWidth = false,
  type = "button",
  variant = "primary",
  ...rest
}: PropsWithChildren<ButtonProps>) {
  return (
    <button
      className={cn(
        "inline-flex items-center justify-center gap-2 rounded-2xl px-4 py-3 text-sm font-semibold transition duration-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed",
        variantClasses[variant],
        fullWidth && "w-full",
        className
      )}
      disabled={disabled}
      type={type}
      {...rest}
    >
      {children}
    </button>
  );
}
